import { UseMutationResult, useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import axiosInstance from "../../shared/service/axios";
import {
  CompanyUpdateRequest,
  CompanyUpdateResponse,
  SmsCreateRequest,
  SmsCreateResponse,
  SmsResponse,
  SmsUpdateRequest,
  SmsUpdateResponse,
} from "./Company.constants";

export const useCompanyUpdateMutation = (): UseMutationResult<
  CompanyUpdateResponse,
  AxiosError,
  CompanyUpdateRequest
> =>
  useMutation<CompanyUpdateResponse, AxiosError, CompanyUpdateRequest>(
    async (requestValues: CompanyUpdateRequest) => {
      const { data, status } = await axiosInstance.put(
        "company/" + requestValues.companyId + "/",
        requestValues
      );

      data.status = status;

      return data;
    }
  );

export const useSmsUpdateMutation = (): UseMutationResult<
  SmsUpdateResponse,
  AxiosError,
  SmsUpdateRequest
> =>
  useMutation<SmsUpdateResponse, AxiosError, SmsUpdateRequest>(
    async (requestValues: SmsUpdateRequest) => {
      const { data, status } = await axiosInstance.put(
        "sms/" + requestValues.smsId + "/",
        requestValues
      );

      data.status = status;

      return data;
    }
  );

export const useSmsMutation = (): UseMutationResult<
  SmsResponse,
  AxiosError,
  any
> =>
  useMutation<SmsResponse, AxiosError, any>(async () => {
    const { data, status } = await axiosInstance.get("sms/");

    return data;
  });

export const useSmsCreateMutation = (): UseMutationResult<
  SmsCreateResponse,
  AxiosError,
  SmsCreateRequest
> =>
  useMutation<SmsCreateResponse, AxiosError, SmsCreateRequest>(
    async (requestValues: SmsCreateRequest) => {
      const { data, status } = await axiosInstance.post("sms/", requestValues);
      data.status = status;

      return data;
    }
  );
